import _jsx from '@babel/runtime/helpers/jsx';
import React from 'react';
import cn from 'classnames';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getDisplayName, onIframeModalResize, trackEvent, stringIncludes } from '@vpp-frontend-components/common';
import { MediaAction } from '@vpp-frontend-components/media';
import { Iframe } from '@vpp-frontend-components/iframe';
import { ActionModal } from '@vpp-frontend-components/action-modal';
import { ActionRow } from '@vpp-frontend-components/action-row';
const namespace$2 = 'ui-vpp-box';

/**
 * Box component
 * @type {import('../../index.d.ts').Box}
 */
const Box = _ref => {
  let {
    className = '',
    id = null,
    content,
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    return /*#__PURE__*/_jsx("div", {
      className: cn(namespace$2, id, className)
    }, void 0, content.map((contentItem, i) => /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    _jsx(React.Fragment, {}, `${namespace$2}-${i}`, /*#__PURE__*/_jsx("div", {
      className: `${namespace$2}__item`
    }, void 0, contentItem.title ? /*#__PURE__*/_jsx(StyledLabel, {
      as: "p",
      color: "BLACK",
      className: `${namespace$2}__item__title`,
      font_family: "REGULAR",
      font_size: "SMALL",
      text: componentEnhance.jsx(contentItem.title.text, contentItem.title.values)
    }) : null, /*#__PURE__*/_jsx(StyledLabel, {
      as: "p",
      color: "GRAY",
      className: `${namespace$2}__item__subtitle`,
      font_family: "REGULAR",
      text: componentEnhance.jsx(contentItem.subtitle.text, contentItem.subtitle.values)
    })))));
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const ACTION_TYPES = {
  MODAL: 'MODAL',
  LINK: 'LINK'
};
const _excluded$1 = ["header", "action", "runCatchErrorBoundary"];
const namespace$1 = 'ui-box-component';
const {
  MODAL: MODAL$1
} = ACTION_TYPES;
const buildActionComponent = (type, action, modalInitialHeight) => {
  if (type === MODAL$1 || action !== null && action !== void 0 && action.action_type && action.action_type.toUpperCase() === MODAL$1) {
    return ActionModal && /*#__PURE__*/_jsx(ActionModal, {
      label: action.label,
      modalTitle: action.modal_title,
      modalClassName: "ui-pdp-iframe-modal",
      className: `${namespace$1}__action`,
      track: action.track,
      url: action.target,
      closeModalLabel: action.close_modal_label
    }, void 0, /*#__PURE__*/_jsx(Iframe, {
      title: action.label ? action.label.text : null,
      src: action.target,
      onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header'),
      scrolling: "no",
      height: modalInitialHeight
    }));
  }
  return /*#__PURE__*/_jsx(MediaAction, {
    target: action.target,
    onClick: () => {
      if (trackEvent) {
        trackEvent(action.track);
      }
    },
    htmlTarget: action.html_target || '_blank',
    className: `${namespace$1}__action`,
    label: {
      text: action.label ? action.label.text : null
    },
    accessibilityText: action.accessibility_text
  });
};

/**
 * WithBoxComponent Higher Order Component for desktop
 * @type {import('../../index.d.ts').withBoxComponentDesktop}
 */
const withBoxComponentDesktop = function () {
  let {
    type,
    modalInitialHeight
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    modalInitialHeight: 1000
  };
  return WrappedComponent => {
    /**
     * Component wrapped with box layout for desktop
     * @type {React.FC<import('../../index.d.ts').WithBoxComponentDesktopProps>}
     */
    const Component = _ref => {
      let {
          header,
          action = null,
          runCatchErrorBoundary = () => {}
        } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded$1);
      try {
        return /*#__PURE__*/_jsx("div", {
          className: cn(namespace$1, `${namespace$1}-pdp__${rest.state.toLowerCase()}--desktop`)
        }, void 0, header && /*#__PURE__*/_jsx("h2", {
          className: `${namespace$1}__title`
        }, void 0, header), /*#__PURE__*/React.createElement(WrappedComponent, _extends({
          runCatchErrorBoundary: runCatchErrorBoundary
        }, rest)), action && buildActionComponent(type, action, modalInitialHeight));
      } catch (error) {
        /* istanbul ignore next */
        return runCatchErrorBoundary(error);
      }
    };
    Component.displayName = `WithBoxComponent(${getDisplayName(WrappedComponent)})`;
    return Component;
  };
};
const _excluded = ["header", "action", "runCatchErrorBoundary"];
const namespace = 'ui-box-component';
const {
  MODAL
} = ACTION_TYPES;
const getAction = (action, type) => {
  const isNewVersionModal = action && stringIncludes(action.target, 'new_version=true');
  if (type === MODAL && isNewVersionModal) {
    return /*#__PURE__*/_jsx(ActionModal, {
      deviceType: "mobile",
      componentAsLabel: /*#__PURE__*/_jsx(ActionRow, {
        label: action.label.text,
        modifier: "secondary"
      }),
      modalTitle: action.modal_title,
      modalClassName: "ui-pdp-iframe-modal",
      className: `${namespace}__action`,
      track: action.track,
      url: action.target,
      closeModalLabel: action.close_modal_label
    }, void 0, /*#__PURE__*/_jsx(Iframe, {
      title: action.label ? action.label.text : null,
      src: action.target,
      onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header'),
      scrolling: "no",
      width: "100%"
    }));
  }
  return /*#__PURE__*/_jsx(ActionRow, {
    className: `${namespace}__action`,
    linkClassName: "mt-20",
    label: action.label ? action.label.text : null,
    url: action.target,
    modifier: "secondary",
    htmlTarget: action.html_target,
    onClick: () => {
      trackEvent(action.track);
    }
  });
};

/**
 * WithBoxComponent Higher Order Component for mobile
 * @type {import('../../index.d.ts').withBoxComponentMobile}
 */
const withBoxComponentMobile = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return WrappedComponent => {
    /**
     * Component wrapped with box layout for mobile
     * @type {React.FC<import('../../index.d.ts').WithBoxComponentMobileProps>}
     */
    const Component = _ref => {
      let {
          header,
          action = null,
          runCatchErrorBoundary = () => {}
        } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded);
      try {
        return /*#__PURE__*/_jsx("div", {
          className: cn(namespace, `${namespace}-pdp__${rest.state.toLowerCase()}--mobile`)
        }, void 0, /*#__PURE__*/_jsx("h3", {
          className: `${namespace}__title mb-24`
        }, void 0, header), /*#__PURE__*/React.createElement(WrappedComponent, _extends({
          runCatchErrorBoundary: runCatchErrorBoundary
        }, rest)), action && getAction(action, type));
      } catch (error) {
        /* istanbul ignore next */
        return runCatchErrorBoundary(error);
      }
    };
    Component.displayName = `WithBoxComponent(${getDisplayName(WrappedComponent)})`;
    return Component;
  };
};
export { ACTION_TYPES, Box, withBoxComponentDesktop, withBoxComponentMobile };
